var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-filters__buttons"},[_c('TotemButton',{attrs:{"label":_vm.$t('General.clear')},on:{"click":_vm.removeAllTags}}),_c('TotemButton',{staticClass:"mobile-filters__button-done",attrs:{"color":"secondary","label":_vm.$t('General.done')},on:{"click":_vm.hideMoreFilters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }